import { CarrierAccount } from "@redotech/redo-model/carrier-account/carrier-account";
import { CreateCarrierAccount } from "@redotech/redo-model/carrier-account/create-carrier-account";
import * as z from "zod";

export const createCarrierAccount = {
  name: "createCarrierAccount" as const,
  input: CreateCarrierAccount,
  output: z.object({
    merchantCarrierAccounts: z.array(CarrierAccount),
    customerCarrierAccounts: z.array(CarrierAccount),
    redoChildCarrierAccounts: z.array(CarrierAccount),
  }),
};
